const wxBind = {
  path: 'wxBind',
  component: resolve => require(['../../../../pages/home/user/wx-bind'], resolve)
}

export default wxBind



// WEBPACK FOOTER //
// ./src/router/home/user/wx-bind/index.js